module.exports = __webpack_public_path__ + "img/C03TechRiteofRudiobus_ua.0e493ded.webp";